import React, { useState, useEffect } from "react";
import styled, { css, keyframes } from "styled-components";
import tw from "twin.macro";
import Nosotros from "../../images/nosotros.jpg";
import Nosotros2 from "../../images/nosotros2.jpg";
import Nosotros3 from "../../images/nosotros3.jpg";
import Diferencia from "../../images/diferencia.jpg";

const Container = tw.div`relative -mx-8 -mt-8`;
const SingleColumn = tw.div`mx-auto py-4 lg:py-10`;
const Content = tw.div`mt-2`;

const Card = styled.div((props) => [
  tw`md:flex justify-between items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row"
]);

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const SliderWrapper = styled.div`
  ${tw`md:w-1/2 h-80 md:h-144 flex-shrink-0 relative overflow-hidden`}
`;

const SliderImage = styled.div(({ image }) => [
  css`
    background-image: url("${image}");
  `,
  tw`absolute inset-0 bg-cover bg-center transition-opacity duration-1000 ease-in-out`,
  css`
    animation: ${fadeIn} 1s ease-in-out;
  `
]);

const Details = tw.div`w-full my-4 md:mt-0 mx-0 pl-4 md:pl-0 sm:mx-8 lg:mx-4 lg:mx-8 flex gap-0 justify-center flex-col items-start text-left`;
const Subtitle = tw.div`my-2 font-bold tracking-wide text-primary-400`;
const Title = tw.h4`mt-8 text-2xl md:text-4xl font-bold uppercase text-primary-800`;
const Description = tw.p`text-sm md:text-lg leading-snug md:max-w-lg mt-2`;
const List = tw.ul`max-w-2xl mx-auto mt-6 space-y-4 text-left`;
const ListItem = tw.li`flex items-start justify-start gap-2 text-gray-800`;

const CheckIcon = () => <span tw="text-green-600 text-xl">✔️</span>;

// Slider component with fading effect
const FadingImageSlider = ({ images}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <SliderWrapper>
      {images.map((img, i) => (
        <SliderImage
          key={i}
          image={img}
          style={{ opacity: i === index ? 1 : 0 }}
        />
      ))}
    </SliderWrapper>
  );
};

export default function NosotrosSection() {
  const cards = [
    {
      imageSrc: [Nosotros,Nosotros2,Nosotros3],
      subtitle: "Una historia que fermenta con tiempo, trabajo y amor",
      title: "Nosotros",
      description: (
        <>
          Desde 1995, <strong>Panificados Mylen</strong> crece con una misión clara: elaborar panificados que
          conserven el auténtico sabor de lo casero. Nacimos como un emprendimiento familiar, y aunque
          crecimos, seguimos eligiendo el camino más noble: procesos lentos, ingredientes de calidad y manos
          que amasan con pasión.
        </>
      )
    },
    {
      imageSrc: [Diferencia],
      title: "¿Qué nos diferencia?",
      description: (
        <>
          <List>
            <ListItem>
              <CheckIcon />
              Productos pensados para generar bienestar real.
            </ListItem>
            <ListItem>
              <CheckIcon />
              Piezas únicas, elaboradas con dedicación.
            </ListItem>
            <ListItem>
              <CheckIcon />
              Procesos cuidados, con foco en lo nutritivo y lo sabroso.
            </ListItem>
          </List>
        </>
      )
    }
  ];

  return (
    <Container id="nosotros">
      <SingleColumn>
        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              {card.imageSrc.length > 1 ? (
                <FadingImageSlider images={card.imageSrc} />
              ) : (
                <SliderWrapper>
                  <SliderImage image={card.imageSrc[0]} style={{ opacity: 1 }} />
                </SliderWrapper>
              )}
              <Details>
                <Title>{card.title}</Title>
                {card.subtitle && <Subtitle>{card.subtitle}</Subtitle>}
                <Description>{card.description}</Description>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
    </Container>
  );
}
